import { render, staticRenderFns } from "./WebsiteManager.vue?vue&type=template&id=6affe3fd&scoped=true"
import script from "./WebsiteManager.vue?vue&type=script&lang=js"
export * from "./WebsiteManager.vue?vue&type=script&lang=js"
import style0 from "./WebsiteManager.vue?vue&type=style&index=0&id=6affe3fd&prod&lang=scss&scoped=true"
import style1 from "./WebsiteManager.vue?vue&type=style&index=1&id=6affe3fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6affe3fd",
  null
  
)

export default component.exports